export default class FinanceSettlementRequest {
  public amountBorrowed: number = 0;

  public extraAddedValue: number = 0;

  public monthlyPayment: number = 0;

  public deposit: number = 0;

  public contractTermMonths: number = 0;

  public contractStartDate: Date = new Date();

  public guaranteedFutureValue: number = 0;

  public extraSettlementAmount: number = 0;

  public settlementDate: Date = new Date();
}
